import PaperCard from "@/components/PaperCard";
import { FormattedMessage } from "react-intl";
import { graphql, useFragment } from "react-relay";
import { RelatedPapersFragment$key } from "./__generated__/RelatedPapersFragment.graphql";

const RelatedPapersFragment = graphql`
  fragment RelatedPapersFragment on Paper {
    relatedPapers(limit: 6) {
      id
      ...PaperCardFragment
    }
  }
`;

export interface RelatedPapersProps {
  paper: RelatedPapersFragment$key;
}

export default function RelatedPapers(props: RelatedPapersProps) {
  const { relatedPapers } = useFragment(RelatedPapersFragment, props.paper);
  if (relatedPapers.length === 0) return null;
  return (
    <section className="flex flex-col gap-4 pb-16">
      <h2 className="text-grey-900 text-xl font-semibold">
        <FormattedMessage defaultMessage="Related papers" />
      </h2>
      <div className="grid xl:grid-cols-2 grid-cols-1 gap-6">
        {relatedPapers.map((related) => (
          <PaperCard paper={related} key={related.id} />
        ))}
      </div>
    </section>
  );
}
